import React from 'react';

import {MainLayout} from 'widgets/layout';
import {HttpMonitorDetailsScreen} from 'features/http';

const HttpMonitorDetailsPage: React.FC = () => {
    return (
        <MainLayout>
            <HttpMonitorDetailsScreen />
        </MainLayout>
    );
};

export default HttpMonitorDetailsPage;
